import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import CreateButton from 'components/button/CreateButton';
import Header from 'components/ui/general/Header';
import Title from 'components/ui/general/Title';
import DiscountsList from './DiscountsList';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';
import translate from 'components/hoc/translate';

const initialFilters = {
    is_enabled: {
        matchType: filterMatchTypes.equals,
        value: '1',
    },
};

const DiscountsListContainer = (props) => {
    const {
        resource,
        translate,
    } = props;

    return (
        <div>
            <Header>
                <Title title={ translate('resources.discounts.title') } />

                <Actions>
                    <CreateButton basePath={ resource } />
                </Actions>
            </Header>

            <DiscountsList
                { ...props }
                initialFilters={ initialFilters }
            />
        </div>
    );
};

DiscountsListContainer.propTypes = {
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(DiscountsListContainer);



// WEBPACK FOOTER //
// ./src/pages/discounts/list/DiscountsListContainer.js